<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H3VwRk/tc-custom/9781035848331.jpg?1728726136951" alt="This image is the cover for the book Frankie Travels to Aotearoa"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frankie Travels to Aotearoa
      </h1>
      <p class="bookDescription body article font2">
        <p>Embark on a captivating journey with Frankie, a truly unique companion who will show you that travel mates come in all shapes and sizes. From the very first page, you’ll be transported to a distant corner of the world, with Frankie by your side. As your adventures unfold, you’ll encounter new experiences and create unforgettable memories. This book offers a delightful way to document your journey, allowing you to write your own story as Frankie and friends explore and enjoy every moment. Let your imagination run wild and be prepared to be amazed by the adventures and discoveries that await you and Frankie.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Colin Stonelake
      </h2>
      
      <p class="authorDescription body article">Colin was born in Bargoed, a small town in South Wales, United Kingdom, in 1960. After leaving college, he went on to complete his nurse training, eventually taking early retirement in 2021. He immigrated to New Zealand in 2008. Colin still maintains a strong family connection to his mother, Doreen, and his sister, Ann. Since retiring, he has discovered new interests in the creative arts and is an advocate for fundraising for charities in Aotearoa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78b366e9